module.exports = __webpack_public_path__ + "assets/recaptcha.630c4771.svg";